import { useEffect, useState } from 'react'
import ForgotForm1 from './ForgotForm1'
import { useForgotPassword, useConfirmNewPassword } from '@/hooks/api/auth'
import ForgotForm2 from './ForgotForm2'
import ForgotForm3 from './ForgotForm3'

export default function ForgotPassword() {
  const [step, setStep] = useState(1)
  const [user, setUser] = useState('')

  const resetPassword = useForgotPassword()
  const confirmPassword = useConfirmNewPassword()

  useEffect(() => {
    if (resetPassword.isSuccess) setStep(2)
  }, [resetPassword.isSuccess])

  useEffect(() => {
    if (confirmPassword.isSuccess) setStep(3)
  }, [confirmPassword.isSuccess])

  const onSubmitForm1 = (user: string) => {
    resetPassword.mutate(user)
    setUser(user)
  }

  const onSubmitForm2 = (code: string, newPassword: string) => {
    confirmPassword.mutate({ user, code, newPassword })
  }

  if (step === 2) {
    return (
      <ForgotForm2
        onSubmit={onSubmitForm2}
        user={user}
        loading={confirmPassword.isLoading}
        error={confirmPassword.error?.toString() || ''}
      />
    )
  }
  if (step === 3) return <ForgotForm3 />
  return (
    <ForgotForm1
      onSubmit={onSubmitForm1}
      loading={resetPassword.isLoading}
      error={resetPassword.error?.toString() || ''}
    />
  )
}
